export function validatorByIconTheme(value: string) {
  return ['default', 'success', 'primary', 'warning', 'error', 'disabled', 'highlight', 'link'].includes(value);
}

export function validatorByIconSize(value: string) {
  return ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge', 'xxxxlarge'].includes(value);
}

export function validatorByDirection(value: string) {
  return ['horizontal', 'vertical'].includes(value);
}

export function validatorByTextAlign(value: string) {
  return ['left', 'center', 'right'].includes(value);
}

export function validatorByInputType(value: string) {
  return ['text', 'email', 'tel', 'url', 'number'].includes(value);
}

export function validatorByTooltipPlacement(value: string) {
  return ['top-start', 'top', 'top-end', 'bottom-start', 'bottom', 'bottom-end'].includes(value);
}
